import { BaseHubOptions } from "../../BaseHubOptions";
import { IBetBoosterSubscriptionResponse } from "../../common";

export class BetBoosterHubOptions extends BaseHubOptions {
	name: string = "bet-booster";
	commonEventNames: string[] = ['ChannelUpdates'];
	messageResolver = (message: IBetBoosterSubscriptionResponse): object => { return message };
}